import { ChangeEventHandler } from 'react';
import classnames from 'src/util/classnames';

function Switch({
  className,
  readonly,
  round,
  value,
  title,
  onChange,
  'data-testid': dataTestid,
  'aria-labelledby': ariaLabelledby,
  'aria-describedby': ariaDescribedby,
}: {
  className?: string;
  readonly?: boolean;
  round?: boolean;
  value?: boolean;
  title?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  'data-testid'?: string;
  'aria-labelledby'?: string;
  'aria-describedby'?: string;
}) {
  const isReadOnly = readonly || !onChange;

  return (
    <label className={classnames('switch', className, { round, readonly: isReadOnly })} title={title}>
      <input
        type="checkbox"
        data-testid={dataTestid}
        aria-labelledby={ariaLabelledby}
        aria-describedby={ariaDescribedby}
        checked={!!value}
        readOnly={isReadOnly}
        // Checkboxes ignore readOnly, so assistive tech is told explicitly that this one can't be changed.
        aria-readonly={isReadOnly || undefined}
        aria-disabled={isReadOnly || undefined}
        onChange={isReadOnly ? undefined : onChange}
      />
      <span className={classnames('slider', { enabled: !!value })} />
    </label>
  );
}

export default Switch;
